import { render } from "./importForms.vue?vue&type=template&id=257a0972&scoped=true"
import script from "./importForms.vue?vue&type=script&lang=js"
export * from "./importForms.vue?vue&type=script&lang=js"

import "./importForms.vue?vue&type=style&index=0&id=257a0972&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-257a0972"]])

export default __exports__